import React from 'react';
const results = [{
  stat: '7 días',
  text: 'Disminución visible del volumen abdominal.'
}, {
  stat: 'Noches',
  text: 'Mejor calidad de sueño y descanso más profundo.'
}, {
  stat: 'Tardes',
  text: 'Digestión ligera, sin la pesadez típica de la tarde.'
}];
export function Proof() {
  return <section className="bg-gold-soft" data-id="element-168" data-mp="gqhycbsyjmmy">
      <div className="mx-auto max-w-5xl px-6 py-14 lg:py-16" data-id="element-169" data-mp="grj7gaqexz21">
        <p className="max-w-3xl font-display text-xl font-semibold leading-snug text-ink sm:text-2xl" data-id="element-170" data-mp="3p61lqu6y6au3">
          En solo 7 días, la mayoría de nuestras usuarias reportan cambios reales
          en su cuerpo.
        </p>
        <dl className="mt-10 grid gap-8 sm:grid-cols-3" data-id="element-171" data-mp="2s0dqmycmq99">
          {results.map(r => <div key={r.stat} className="border-t border-ink/15 pt-4" data-id="element-172" data-mp="3u4uy2jahzvso">
              <dt className="font-display text-2xl font-semibold text-teal-deep" data-id="element-173" data-mp="36g1xuamuf1s9">
                {r.stat}
              </dt>
              <dd className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-174" data-mp="31g7c0lhxd2e2">
                {r.text}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}